import * as React from 'react';
import {
    MoreLessGroup,
    LinkMoreLessWrapper,
    ChevronIconWrapper,
} from 'src/domains/sportsbook/webview/components/expandButton/ExpandButton.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    isExpanded: boolean;
    isHomepage?: boolean;
    toggleExpand(e: React.MouseEvent): void;
}

export const ExpandButton = (props: PropsType): JSX.Element => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    return (
        <MoreLessGroup
            isHomepage={props.isHomepage}
            variant={configState.componentVariants.sportsbookVariant}
        >
            <LinkMoreLessWrapper onClick={props.toggleExpand}>
                {props.isExpanded ? (
                    <I18n
                        langKey='events.selections-group.less'
                        defaultText='Less'
                    />
                ) : (
                    <I18n
                        langKey='events.selections-group.more'
                        defaultText='More'
                    />
                )}

                <ChevronIconWrapper position={props.isExpanded ? 'up' : 'down'} />
            </LinkMoreLessWrapper>
        </MoreLessGroup>
    );
};
